export const route = {
	login: 'login',
	home: 'home',
	project: 'project',
	edit: 'project/edit',
	add: 'project/add',
	user: 'user',
	users: 'users',
	tempUsers: 'users/temporary',
	codes: 'project/code',
	groups: 'project/groups',
	categories: 'project/categories',
	dataSheets: 'project/data-sheets',
	downloads: 'project/downloads',
	status: 'project/status',
    reference: 'project/reference',
	userGuide: 'user-guide',
	file: 'file',
	projects: 'projects',
};
